import { Theme, css } from '@emotion/react';
import { ToggleButtonProps } from '@material-ui/lab';

const getSizeVars = (size: ToggleButtonProps['size']) => {
  switch (size) {
    case 'small':
      return css`
        --button-size: 32px;
      `;
    case undefined:
    case 'medium':
      return css`
        --button-size: 36px;
      `;
    case 'large':
      return css`
        --button-size: 44px;
      `;
  }
};

export const toggleButtonBase =
  (size: ToggleButtonProps['size'], selected: boolean) =>
  ({ colors, interactiveStates, spacing, typography, shape }: Theme) => {
    return css`
      ${getSizeVars(size)}
      height: var(--button-size);
      min-width: var(--button-size);
      color: ${colors.fgDefault};
      padding: 0 ${spacing(1.5)}px;
      ${typography.variant('bodyStrong')};
      text-transform: none;
      border: 1px solid ${colors.borderDefault};

      ${interactiveStates.hover(css`
        background: ${colors.bgLighter};
      `)}

      ${interactiveStates.active(css`
        background: ${colors.bgLighter};
      `)}

      ${interactiveStates.disabled(css`
        background: ${colors.bgDefault};
        color: ${colors.fgDisabled};
      `)}

      ${interactiveStates.focus(css`
        background: ${colors.bgLighter};
        outline: 2px solid ${colors.borderPrimaryBase};
        outline-offset: 2px;
        z-index: 2;
      `)}

      &.Mui-selected {
        border: 1px solid ${colors.borderPrimaryDark};
        background: ${colors.bgPrimaryLighter};
        color: ${colors.fgPrimaryDark};
      }

      &.Mui-selected:hover:not(:disabled):not([aria-disabled='true']):not(:active) {
        background: var(--royal-light);
      }

      &.Mui-selected:active:not(:disabled):not([aria-disabled='true']) {
        background: var(--royal-light);
      }

      &:not(.Mui-selected).MuiButtonBase-root:hover {
        border-left: 1px solid ${colors.borderDefault};
      }

      &:not(.Mui-selected).MuiButtonBase-root:active {
        border-left: 1px solid ${colors.borderDefault};
      }

      &.Mui-selected + .MuiButtonBase-root,
      &.Mui-selected + .MuiButtonBase-root:hover {
        border-left: 1px solid ${colors.borderPrimaryBase};
      }

      &.Mui-selected + &.Mui-selected {
        border-left: none;
      }
    `;
  };

export const toggleIconButtonBase = css`
  padding: 0;
`;
